module.exports = __webpack_public_path__ + "img/snow-leopard-title.32f8ea20.png";